(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/play/utils/particle-renderer.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/play/utils/particle-renderer.js');
"use strict";



setGlobal('svs.tickets.play.utils.particleRenderer', _ref => {
  let drawObject = _ref.drawObject,
    world = _ref.world,
    canvas = _ref.canvas,
    particlePerPixel = _ref.particlePerPixel,
    _ref$minParticles = _ref.minParticles,
    minParticles = _ref$minParticles === void 0 ? 0 : _ref$minParticles;
  let stopped = false;
  const ctx = canvas.getContext('2d');
  let currentWorld;
  let objects = [];
  let count = canvas.height * canvas.width * particlePerPixel;
  count = count < minParticles ? minParticles : count;
  let targetCount = count;

  let fps = 0;
  let fpsThreshold = null;
  let shouldCallibrateFPS = false;
  setTimeout(() => {
    shouldCallibrateFPS = true;
  }, 5000);
  addEventListener('focus', () => {
    fpsThreshold = performance.now();
  });
  let frameCount = 0;
  let t0;
  let tStart;
  const render = () => {
    if (stopped) {
      return;
    }

    const t1 = performance.now();
    const delta = t1 - t0;
    const delta0 = t1 - tStart;
    t0 = t1;
    shouldCallibrateFPS && checkFps();
    tick(delta, delta0);
    redraw();

    frameCount++;
    requestAnimationFrame(render);
  };

  const start = () => {
    tStart = performance.now();
    t0 = tStart;
    setInterval(() => {
      fps = frameCount;
      frameCount = 0;
    }, 1000);

    currentWorld = world;

    for (let i = 0; i < count; i++) {
      objects.push(drawObject(currentWorld));
    }
    currentWorld.objects = objects;

    requestAnimationFrame(render);
  };

  const tick = (delta, delta0) => {
    var _currentWorld;
    (_currentWorld = currentWorld) === null || _currentWorld === void 0 || _currentWorld.update(delta0);
    for (let i = 0; i < targetCount; i++) {
      const obj = objects[i];
      if (obj.isEndOfLife) {
        objects[i] = drawObject(currentWorld);
      } else {
        obj === null || obj === void 0 || obj.update(objects[i], currentWorld, delta0, delta);
      }
    }
  };

  const redraw = () => {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    for (let i = 0; i < targetCount; i++) {
      var _objects$i;
      (_objects$i = objects[i]) === null || _objects$i === void 0 || _objects$i.draw(objects[i], ctx);
    }
  };

  const checkFps = () => {
    if (fps < 60) {
      if (fpsThreshold !== 0 && fpsThreshold - performance.now() < -4000) {
        const target = Math.floor(objects.length * (fps / 60));
        targetCount = target;
        fpsThreshold = 0;
      } else if (fpsThreshold === 0) {
        fpsThreshold = performance.now();
      }
    } else {
      if (fps > 70 && frameCount % 10 === 0 && targetCount < count) {
        targetCount++;
      }
      fpsThreshold = 0;
    }
  };
  addEventListener('resize', _.debounce(() => {
    count = canvas.height * canvas.width * particlePerPixel;
    count = count < minParticles ? minParticles : count;
    targetCount = count;
    objects = [];
    for (let i = 0; i < count; i++) {
      objects.push(drawObject(currentWorld));
    }
  }, 1000));

  const destroy = () => {
    stopped = true;
    canvas.remove();
  };
  start();
  return {
    start,
    destroy
  };
});

 })(window);